import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import { fetchClinicSettings, fetchVeterinarians } from '../store/settingsSlice'
import { ClinicInformation } from '../components/settings/ClinicInformation'
import { VeterinariansSection } from '../components/settings/VeterinariansSection'
import { DefaultUnits } from '../components/settings/DefaultUnits'

export function SettingsPage() {
  const dispatch = useAppDispatch()
  const loading = useAppSelector((s) => s.settings.loading)

  useEffect(() => {
    dispatch(fetchClinicSettings())
    dispatch(fetchVeterinarians())
  }, [dispatch])

  if (loading) {
    return (
      <div className="p-6 max-sm:p-3" data-testid="settings-page">
        <p className="text-[13px] text-text-muted">Loading settings...</p>
      </div>
    )
  }

  return (
    <div className="p-6 max-sm:p-3" data-testid="settings-page">
      <h1 className="text-[16px] font-semibold text-text-primary mb-6">Settings</h1>

      <div className="flex flex-col gap-8 max-w-xl">
        <ClinicInformation />
        <div className="h-px bg-border" />
        <VeterinariansSection />
        <div className="h-px bg-border" />
        <DefaultUnits />
      </div>
    </div>
  )
}
